import script from "./ConfirmationPopup.vue?vue&type=script&setup=true&lang=js"
export * from "./ConfirmationPopup.vue?vue&type=script&setup=true&lang=js"

import "./ConfirmationPopup.vue?vue&type=style&index=0&id=7b08bf13&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7b08bf13"]])

export default __exports__